import type { Action } from '../action'
import { ResourceType } from '../resource-type'

/**
 * Managing grants: direct policies and roles. Self-referential — no
 * controller method sits behind them, they gate the policies API itself.
 *
 * `admin:role:assign` is deliberately separate from `admin:policy:write`:
 * assigning points at a definition someone else controls, while writing a
 * policy authors statements directly. A grant can confer one without the other
 */
export const POLICY_ACTIONS = {
  'admin:policy:read': {
    description: "Read a user's direct policies and role assignments",
    resourceTypes: [ResourceType.User],
  },
  'admin:policy:write': {
    description: 'Create or replace a direct policy on a user',
    resourceTypes: [ResourceType.User],
  },
  'admin:policy:delete': {
    description: 'Revoke a direct policy from a user',
    resourceTypes: [ResourceType.User],
  },
  'admin:role:create': {
    description: 'Define a new role',
    resourceTypes: [ResourceType.Tenant],
  },
  'admin:role:update': {
    description: "Edit a role's statements",
    resourceTypes: [ResourceType.Tenant],
  },
  'admin:role:delete': {
    description: 'Remove a role definition',
    resourceTypes: [ResourceType.Tenant],
  },
  'admin:role:assign': {
    description: 'Assign a role to a user, or unassign it',
    resourceTypes: [ResourceType.User],
  },
} as const satisfies Record<string, Action.Definition>
